import { create } from 'zustand';

const usePreloaderStore = create((set) => ({
    isActive: false,
    show: () => set({ isActive: true }),
    hide: () => set({ isActive: false }),
}));

export default usePreloaderStore;
